
    <!--
 * 竖版-首页
 * @LastEditTime: Wed Dec 18 2024 22:40:11 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_P04K62"  :class="[`normal`,`u_c_P04K62`]" ><a id="u_c_Z1IM63" href="javascript:;" :class="[`normal`,`u_c_Z1IM63`]" @click="u_c_Z1IM63_event_UPX839($event)">{{`${ langData.infoBtn }`}}</a><div id="u_c_50O017"  v-html="compData.titleText" :class="[`normal`,`u_c_50O017`]" ></div><div id="u_c_KXRA66"  :class="[`normal`,`u_c_KXRA66`]" ><div id="u_c_TIHK120"  v-html="compData.ruleInfo" :class="[`normal`,`u_c_TIHK120`]" ></div></div><div id="u_c_8RZZ20"  :class="[`normal`,`u_c_8RZZ20`]" ><div id="u_c_HBAD21"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_HBAD21`]" ><div id="u_c_K2CW22"  :class="[`normal txt`,`u_c_K2CW22`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_N7QL23" href="javascript:;" :class="[`normal txt btn`,`u_c_N7QL23`]" @click="u_c_N7QL23_event_2ODI38($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_MYY124"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_MYY124`]" ><div id="u_c_HE1828"  v-show="pageData.isBind" :class="[`normal txt btn`,`u_c_HE1828`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_FT4T29"  :class="[`normal`,`u_c_FT4T29`]" ><a id="u_c_OFYI30" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn`,`u_c_OFYI30`]" @click="u_c_OFYI30_event_4VGM39($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_KOJG31" href="javascript:;" v-show="pageData.isBind && compData.canChangeRole" :class="[`normal txt btn`,`u_c_KOJG31`]" @click="u_c_KOJG31_event_BH2440($event)">{{`[${ langData.changeRole }]`}}</a><a id="u_c_DAVR33" href="javascript:;" :class="[`normal txt btn`,`u_c_DAVR33`]" @click="u_c_DAVR33_event_4UM441($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_6Y3W32" href="javascript:;" :class="[`normal txt btn`,`u_c_6Y3W32`]" @click="u_c_6Y3W32_event_KKCX42($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"ruleInfo":`活动说明：在指定充值渠道充值达到一定金额，即可获得奖励，该活动为长期活动,累计充值分为每日累充及终身累充（具体充值渠道及规则请查询活动规则）`,"showBag":true,"titleText":`累计充值领好礼`,"canChangeRole":false},"zh-TW":{"ruleInfo":`活動說明：在活動開啟期間內，在指定儲值管道儲值達到一定金額，即可獲得對應獎勵。該活動為每季度限時活動，累計儲值為活動期間累計。（具體儲值管道請查閱活動規則）`,"showBag":true,"titleText":`累計儲值領好禮`,"canChangeRole":false}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const canClickChange = ref(true);
const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";;
      // 活动规则的click事件
      const u_c_Z1IM63_event_UPX839= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_N7QL23_event_2ODI38= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_OFYI30_event_4VGM39= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_KOJG31_event_BH2440= async (e)=>{
        try {if(!canClickChange.value)return;

canClickChange.value = false;

const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=resetUserBind`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=resetUserBind`,
}
let res = await request.getJSON(link[curPlatform])
canClickChange.value = true;

if(res.result!=1){
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName ="";
pageData.serverName = "";
} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_DAVR33_event_4UM441= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_6Y3W32_event_KKCX42= async (e)=>{
        try {let link = {
  gm99: `https://passport.gm99.com/login/logout2`,
  global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
}
let res = await request.getJSON(link[curPlatform])
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_P04K62.normal{
position:relative;
background-size:cover;
width:10.00rem;
height:8.09rem;
overflow:hidden;
margin:auto;

}
}.default{
.u_c_Z1IM63.normal{
position:absolute;
top:0.39rem;
right:0.27rem;
font-size:0.40rem;
color:#121c17;
text-decoration:none;
text-align:center;

}
}.default{
.u_c_50O017.normal{
position:relative;
width:85%;
margin:0 auto;
text-align:center;
margin-top:1.65rem;
font-size:1.07rem;
color:#4E8E72;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_KXRA66.normal{
position:relative;
width:85%;
height:1.80rem;
margin:0 auto;
margin-top:0.76rem;

}
}.default{
.u_c_TIHK120.normal{
position:relative;
font-size:0.29rem;
color:#51675f;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_8RZZ20.normal{
position:relative;
margin:auto;
margin-top:0.15rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8RZZ20.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8RZZ20.normal .txt{
font-size:0.29rem;
color:#51675f;

}

.u_c_8RZZ20.normal .btn{
margin:auto 0.13rem;

}
}.default{
.u_c_HBAD21.normal{
position:relative;

}
}.default{
.u_c_K2CW22.normal{
position:relative;

}
}.default{
.u_c_N7QL23.normal{
position:relative;

}
}.default{
.u_c_MYY124.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_HE1828.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_FT4T29.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_OFYI30.normal{
position:relative;

}
}.default{
.u_c_KOJG31.normal{
position:relative;

}
}.default{
.u_c_DAVR33.normal{
position:relative;

}
}.default{
.u_c_6Y3W32.normal{
position:relative;

}
}.zh-TW{
.u_c_P04K62.normal{
position:relative;
background-size:cover;
width:10.00rem;
height:8.09rem;
overflow:hidden;
margin:auto;

}
}.zh-TW{
.u_c_Z1IM63.normal{
position:absolute;
top:0.39rem;
right:0.27rem;
font-size:0.40rem;
color:#121c17;
text-decoration:none;
text-align:center;

}
}.zh-TW{
.u_c_50O017.normal{
position:relative;
width:85%;
margin:0 auto;
text-align:center;
margin-top:1.65rem;
font-size:1.07rem;
color:#4E8E72;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_KXRA66.normal{
position:relative;
width:85%;
height:1.80rem;
margin:0 auto;
margin-top:0.76rem;

}
}.zh-TW{
.u_c_TIHK120.normal{
position:relative;
font-size:0.29rem;
color:#51675f;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_8RZZ20.normal{
position:relative;
margin:auto;
margin-top:0.15rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8RZZ20.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8RZZ20.normal .txt{
font-size:0.29rem;
color:#51675f;

}

.u_c_8RZZ20.normal .btn{
margin:auto 0.13rem;

}
}.zh-TW{
.u_c_HBAD21.normal{
position:relative;

}
}.zh-TW{
.u_c_K2CW22.normal{
position:relative;

}
}.zh-TW{
.u_c_N7QL23.normal{
position:relative;

}
}.zh-TW{
.u_c_MYY124.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-TW{
.u_c_HE1828.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_FT4T29.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_OFYI30.normal{
position:relative;

}
}.zh-TW{
.u_c_KOJG31.normal{
position:relative;

}
}.zh-TW{
.u_c_DAVR33.normal{
position:relative;

}
}.zh-TW{
.u_c_6Y3W32.normal{
position:relative;

}
}
</style>
